import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React from 'react';

const { Dragger } = Upload;

const UploadFile = ({ setFile }) => {
  const handleUpload = (e) => {
    setFile(e.file);
  };

  return (
    <>
      <Dragger
        accept=".xlsx, .csv"
        onChange={handleUpload}
        beforeUpload={() => false}
        style={{padding: '3rem'}}
      >
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text">
          Puede arrastrar y soltar archivos aquí para añadirlos
        </p>
        <p className="ant-upload-hint">Sólo se admite formato .xlsx y .csv</p>
      </Dragger>
    </>
  );
};

export default UploadFile;
